import { render, staticRenderFns } from "./AutorizacaoList.vue?vue&type=template&id=0bb9c8b4&scoped=true"
import script from "./AutorizacaoList.vue?vue&type=script&lang=js"
export * from "./AutorizacaoList.vue?vue&type=script&lang=js"
import style0 from "./AutorizacaoList.vue?vue&type=style&index=0&id=0bb9c8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9c8b4",
  null
  
)

export default component.exports